var shvenergy = shvenergy || {};